<template>
  <div id="contenedor-main-contrato" class="bkground">
    <v-container
      fluid>
      <v-card
        flat
        class="mb-4 rounded-lg">
        <v-card-text>
          <titulo-tool-bar
            v-if="!$apollo.queries.contrato.loading"
            :titulo="getContrato.numero"
            nombreRuta="contratitasContratos"
            regresar>
          </titulo-tool-bar>
          <v-tabs>
            <template v-for="(opcion, index) in opciones">
              <template>
                <v-tab
                  :key="index"
                  :to="{ name: opcion.ruta }"
                  exact>
                  {{ opcion.nombre }}
                </v-tab>
              </template>
            </template>
          </v-tabs>
        </v-card-text>
      </v-card>
      <v-card
        color="transparent"
        flat>
        <v-card-text class="pa-0">
          <router-view></router-view>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';

export default {
  name: 'MainContrato',
  components: {
    TituloToolBar,
  },
  data() {
    return {
      opciones: [
        {
          nombre: 'Generales',
          ruta: 'contratistaContratoGenerales',
          icono: '',
        },
        {
          nombre: 'Directorio',
          ruta: 'contratistaContratoDirectorio',
          icono: '',
        },
        {
          nombre: 'Frentes',
          ruta: 'contratistaContratoFrentes',
          icono: '',
        },
        {
          nombre: 'Diario de actividades',
          ruta: 'contratistaContratoDiarioActividades',
          icono: '',
        },
        {
          nombre: 'Minutas',
          ruta: 'contratistrasContratoMinutas',
          icono: '',
        },
        {
          nombre: 'Agenda',
          ruta: 'contratistaContratoAgenda',
          icono: '',
        },
        {
          nombre: 'Reportes',
          ruta: 'contratistaContratoReportesFisicos',
          icono: '',
        },
        {
          nombre: 'Anticipos',
          ruta: 'contratistaContratoEstimacionesAnticipos',
          icono: '',
        },
        {
          nombre: 'Convenios mod.',
          ruta: 'contratistasContratoConveniosModificatorios',
          icono: '',
        },
        {
          nombre: 'Catálogo',
          ruta: 'contratistasContratoCatalogo',
          icono: '',
        },
        {
          nombre: 'Programa',
          ruta: 'contratistaContratoPrograma',
          icono: '',
        },
        {
          nombre: 'Expediente',
          ruta: 'contratistasContratoExpediente',
          icono: '',
        },
        {
          nombre: 'Archivos',
          ruta: 'contratistaContratoArchivos',
          icono: '',
        },
        /*
        {
          nombre: 'Directorio',
          ruta: 'contratistaContratoDirectorio',
          icono: '',
        },
        */
      ],
    };
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
  },
};
</script>

<style lang="scss">

</style>
